import { useTranslation } from "react-i18next";
import { Stack, Typography, useTheme } from "@mui/material";
import * as React from "react";

interface IViewSimpleProperty {
        label: string;
        value: string;
        error: boolean;
}

/**
 * Section to view simple property of Disambiguation details
 */
const ViewSimpleProperty = (props: IViewSimpleProperty) => {

    const {t} = useTranslation('booking');

    const theme = useTheme();

    return (
        <>

            <Stack direction="row" justifyContent="space-between" columnGap={5} px={1}
                   style={!!props?.error ? {background: theme.palette.neutral.light, borderRadius: 3} : {}}
             >
                <Typography>
                    {props?.label}
                </Typography>
                <Typography fontWeight={550}
                            sx={{
                                color:
                                    !!props?.error
                                        ? theme.palette.error.main
                                        : '',
                            }}>
                    {!!props?.value ? props?.value : '-'}
                </Typography>
            </Stack>
        </>
    );
}

export default ViewSimpleProperty;
